import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { StockOverviewRoutingModule } from './stock-overview-routing.module';
import { StockOverviewComponent } from 'src/app/cabinet/stock-overview/stock-overview.component';
import { FundamentalsComponent } from 'src/app/cabinet/fundamentals/fundamentals.component';
import { RelatedStocksComponent } from 'src/app/cabinet/related-stocks/related-stocks.component';
import { StockFinancialsComponent } from 'src/app/cabinet/stock-financials/stock-financials.component';
import { StockNewsComponent } from 'src/app/cabinet/stock-news/stock-news.component';
import { StockPressReleasesComponent } from 'src/app/cabinet/stock-press-releases/stock-press-releases.component';
import { StockRecommendationComponent } from 'src/app/cabinet/stock-recommendation/stock-recommendation.component';
import { BuysellComponent } from 'src/app/shared/components/buysell/buysell.component';
import { ComplianceStatusCardComponent } from 'src/app/shared/components/compliance-status-card/compliance-status-card.component';
import { TopUserCollectionsComponent } from 'src/app/shared/components/dashboard/top-user-collections/top-user-collections.component';
import { DetailsHeaderComponent } from 'src/app/shared/components/details-header/details-header.component';
import { DetailsTabBtnsComponent } from 'src/app/shared/components/details-tab-btns/details-tab-btns.component';
import { FeatureLockedCardComponent } from 'src/app/shared/components/feature-locked-card/feature-locked-card.component';
import { InvestmentChecklistComponent } from 'src/app/shared/components/investment-checklist/investment-checklist.component';
import { NoDataCardComponent } from 'src/app/shared/components/no-data-card/no-data-card.component';
import { ScreenerReportComponent } from 'src/app/shared/components/screener-report/screener-report.component';
import { PurificationCardComponent } from 'src/app/shared/components/stock-details/purification-card/purification-card.component';
import { StockProfileComponent } from 'src/app/shared/components/stock-profile/stock-profile.component';
import { SuperinvestorsStockOverviewListComponent } from 'src/app/shared/components/super-investors/superinvestors-stock-overview-list/superinvestors-stock-overview-list.component';
import { TooltipComponent } from 'src/app/shared/components/tooltip/tooltip.component';
import { TradingChartComponent } from 'src/app/shared/components/trading-chart/trading-chart.component';
import { TradingViewComponent } from 'src/app/shared/trading-view/trading-view.component';
import { ForecastsComponent } from 'src/app/shared/components/forecasts/forecasts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import {
   NgbProgressbarModule,
   NgbPaginationModule,
   NgbDropdownModule,
   NgbTooltipModule,
   NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgChartsModule } from 'ng2-charts';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ShareButtons } from 'ngx-sharebuttons/buttons';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { ShareButtonDirective } from 'ngx-sharebuttons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AddListsComponent } from 'src/app/cabinet/add-lists/add-lists.component';
import { DebtChartComponent } from 'src/app/shared/components/debt-chart/debt-chart.component';
import { IncomeBreakdownComponent } from 'src/app/shared/components/income-breakdown/income-breakdown.component';
import { LimitReachedCardComponent } from 'src/app/shared/components/limit-reached-card/limit-reached-card.component';
import { RevenueBreakdownChartComponent } from 'src/app/shared/components/revenue-breakdown-chart/revenue-breakdown-chart.component';
import { SampleBubbleComponent } from 'src/app/shared/components/sample-bubble/sample-bubble.component';
import { ProgresChartComponent } from 'src/app/shared/components/progres-chart/progres-chart.component';
import { LessThanTooltipComponent } from 'src/app/shared/components/less-than-tooltip/less-than-tooltip.component';
import { ForecastDataBarChartComponent } from 'src/app/shared/components/forecast-data-bar-chart/forecast-data-bar-chart.component';
import { ForecastDataSectionComponent } from 'src/app/shared/components/forecast-data-section/forecast-data-section.component';
import { ForecastPriceChartComponent } from 'src/app/shared/components/forecast-price-chart/forecast-price-chart.component';
import { ForecastPriceDataSectionComponent } from 'src/app/shared/components/forecast-price-data-section/forecast-price-data-section.component';
import { WatchlistButtonComponent } from 'src/app/shared/components/dashboard/watchlist-button/watchlist-button.component';
import { ShareLinksPopupComponent } from 'src/app/shared/components/share-links-popup/share-links-popup.component';
import { AbsPipe } from 'src/app/shared/pipes/abs.pipe';
import { CategoryToTextPipe } from 'src/app/shared/pipes/category-to-text.pipe';
import { ProfileTextPipe } from 'src/app/shared/pipes/profile-text';
import { screaningMillionPipe } from 'src/app/shared/pipes/screaning-million.pipe';
import { SumPipe } from 'src/app/shared/pipes/sum.pipe';
import { ComplianceHistoryComponent } from 'src/app/shared/components/compliance-history/compliance-history.component';
import { MillionPipe } from 'src/app/shared/pipes/million.pipe';
import { currencyMilionPipe } from 'src/app/shared/pipes/currencyMilion.pipe';
import { AnalystRatingGuageChartComponent } from 'src/app/shared/components/analyst-rating-guage-chart/analyst-rating-guage-chart.component';
import { RankingGradePipe } from 'src/app/shared/pipes/ranking-grade.pipe';
import { ComplianceChipComponent } from 'src/app/shared/components/compliance-chip/compliance-chip.component';
import { FStatementsComponent } from 'src/app/cabinet/stock-financials/f-statements/f-statements.component';
import { PsDataComponent } from 'src/app/cabinet/stock-financials/ps-data/ps-data.component';
import { RatiosComponent } from 'src/app/cabinet/stock-financials/ratios/ratios.component';
import { BalancesheetAnnualChartComponent } from 'src/app/cabinet/stock-financials/f-statements/balancesheet/balancesheet-annual-chart/balancesheet-annual-chart.component';
import { BalancesheetChartComponent } from 'src/app/cabinet/stock-financials/f-statements/balancesheet/balancesheet-chart/balancesheet-chart.component';
import { BalancesheetTableComponent } from 'src/app/cabinet/stock-financials/f-statements/balancesheet/balancesheet-table/balancesheet-table.component';
import { BalancesheetComponent } from 'src/app/cabinet/stock-financials/f-statements/balancesheet/balancesheet.component';
import { CashflowAnnualChartComponent } from 'src/app/cabinet/stock-financials/f-statements/f-cashflow/cashflow-annual-chart/cashflow-annual-chart.component';
import { CashflowChartComponent } from 'src/app/cabinet/stock-financials/f-statements/f-cashflow/cashflow-chart/cashflow-chart.component';
import { FCashflowTableComponent } from 'src/app/cabinet/stock-financials/f-statements/f-cashflow/f-cashflow-table/f-cashflow-table.component';
import { FCashflowComponent } from 'src/app/cabinet/stock-financials/f-statements/f-cashflow/f-cashflow.component';
import { IncomeStatementAnnualChartComponent } from 'src/app/cabinet/stock-financials/f-statements/income-statement/income-statement-annual-chart/income-statement-annual-chart.component';
import { IncomeStatementChartComponent } from 'src/app/cabinet/stock-financials/f-statements/income-statement/income-statement-chart/income-statement-chart.component';
import { IncomeStatementTableComponent } from 'src/app/cabinet/stock-financials/f-statements/income-statement/income-statement-table/income-statement-table.component';
import { IncomeStatementComponent } from 'src/app/cabinet/stock-financials/f-statements/income-statement/income-statement.component';
import { LoaderComponentComponent } from 'src/app/cabinet/stock-financials/ratios/loader-component/loader-component.component';
import { RatioAnnualChartComponent } from 'src/app/cabinet/stock-financials/ratios/ratio-annual-chart/ratio-annual-chart.component';
import { RatiosChartComponent } from 'src/app/cabinet/stock-financials/ratios/ratios-chart/ratios-chart.component';
import { RatiosTableComponent } from 'src/app/cabinet/stock-financials/ratios/ratios-table/ratios-table.component';
import { BarChartComponent } from 'src/app/cabinet/stock-financials/ps-data/bar-chart/bar-chart.component';
import { TableComponent } from 'src/app/cabinet/stock-financials/ps-data/table/table.component';
import { OrderByPipe } from 'src/app/shared/pipes/order-by.pipe';
import { AddListsCreateComponent } from 'src/app/cabinet/add-lists-create/add-lists-create.component';
import { KeyToLabelPipe } from 'src/app/shared/pipes/key-to-label.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LimitReachedPopupComponent } from 'src/app/shared/components/limit-reached-popup/limit-reached-popup.component';
import { IriReportComponent } from 'src/app/cabinet/iri-report/iri-report.component';
import { CompanyInfoComponent } from 'src/app/cabinet/company-info/company-info.component';
import { FaqsComponent } from 'src/app/cabinet/faqs/faqs.component';
// import { InvestorRelationsComponent } from 'src/app/cabinet/investor-relations/investor-relations.component';
import { IriLockComponent } from 'src/app/cabinet/iri-report/iri-lock/iri-lock.component';
import { RatingModalComponent } from 'src/app/cabinet/iri-report/rating-modal/rating-modal.component';
import { ScoreRadarCardComponent } from 'src/app/cabinet/iri-report/score-radar-card/score-radar-card.component';
import { MarketComparisonComponent } from 'src/app/cabinet/market-comparison/market-comparison.component';
import { NewInvestmentChecklistComponent } from 'src/app/shared/components/new-investment-checklist/new-investment-checklist.component';
import { AssessmentSliderLeftComponent } from 'src/app/cabinet/iri-report/assessment-slider-left/assessment-slider-left.component';
import { AssessmentSliderRightComponent } from 'src/app/cabinet/iri-report/assessment-slider-right/assessment-slider-right.component';
import { CommunityScoreComponent } from 'src/app/cabinet/iri-report/community-score/community-score.component';
import { MusaffaScoreComponent } from 'src/app/cabinet/iri-report/musaffa-score/musaffa-score.component';
import { ScoreRatingSliderComponent } from 'src/app/cabinet/iri-report/score-rating-slider/score-rating-slider.component';
import { DynamicTableComponent } from 'src/app/shared/components/dynamic-table/dynamic-table.component';
import { MainWrapperModule } from '../main-wrapper/main-wrapper/main-wrapper.module';
import { IpoComponentComponent } from 'src/app/features/ipo-component/ipo-component.component';
import { IpoDataComponent } from 'src/app/features/ipo-data/ipo-data.component';
import { IpoDetailsComponent } from 'src/app/features/ipo-details/ipo-details.component';
import { IpoDataLockComponent } from 'src/app/shared/components/ipo-data-lock/ipo-data-lock.component';
import { CabinetRoutingModule } from 'src/app/cabinet/cabinet-routing.module';
import { PremiumSamplePopupComponent } from 'src/app/shared/components/premium-sample-popup/premium-sample-popup.component';
import { PurificationCalculatorComponent } from 'src/app/shared/components/purification-calculator/purification-calculator.component';
import { PurificationOptionsComponent } from 'src/app/shared/components/purification-options/purification-options.component';
import { EtfScreenerReportComponent } from 'src/app/shared/components/etf-screener-report/etf-screener-report.component';
import { EtfScreeningDetailedReportComponent } from 'src/app/shared/components/etf-screening-detailed-report/etf-screening-detailed-report.component';
import { LoginFormComponent } from 'src/app/authentication/login-form/login-form.component';
import { SignupFormComponent } from 'src/app/authentication/signup-form/signup-form.component';
import { VerifyOtpComponent } from 'src/app/authentication/verify-otp/verify-otp.component';
import { ForgotPasswordFormComponent } from 'src/app/authentication/forgot-password-form/forgot-password-form.component';
import { FacebookLoginComponent } from 'src/app/shared/components/facebook-login/facebook-login.component';
import { AppleLoginComponent } from 'src/app/shared/components/apple-login/apple-login.component';
import { GoogleSigninComponent } from 'src/app/shared/components/google-signin/google-signin.component';
import { AuthPopupComponent } from 'src/app/authentication/auth-popup/auth-popup.component';
import { SlugifyPipe } from 'src/app/shared/pipes/slugify.pipe';

@NgModule({
   declarations: [
      StockOverviewComponent,
      DetailsHeaderComponent,
      DetailsTabBtnsComponent,
      BuysellComponent,
      TradingViewComponent,
      TradingChartComponent,
      ComplianceStatusCardComponent,
      PurificationCardComponent,
      StockRecommendationComponent,
      FundamentalsComponent,
      InvestmentChecklistComponent,
      SuperinvestorsStockOverviewListComponent,
      TopUserCollectionsComponent,
      RelatedStocksComponent,
      ScreenerReportComponent,
      FeatureLockedCardComponent,
      StockFinancialsComponent,
      NoDataCardComponent,
      StockNewsComponent,
      StockPressReleasesComponent,
      StockProfileComponent,
      TooltipComponent,
      ForecastsComponent,
      AddListsComponent,
      LimitReachedCardComponent,
      LimitReachedPopupComponent,
      SampleBubbleComponent,
      RevenueBreakdownChartComponent,
      IncomeBreakdownComponent,
      DebtChartComponent,
      ProgresChartComponent,
      LessThanTooltipComponent,
      ForecastPriceDataSectionComponent,
      ForecastPriceChartComponent,
      ForecastDataSectionComponent,
      ForecastDataBarChartComponent,
      WatchlistButtonComponent,
      ShareLinksPopupComponent,
      ComplianceHistoryComponent,
      AnalystRatingGuageChartComponent,
      ComplianceChipComponent,
      PsDataComponent,
      RatiosComponent,
      RatiosTableComponent,
      RatiosChartComponent,
      FStatementsComponent,
      IncomeStatementComponent,
      BalancesheetComponent,
      FCashflowComponent,
      IncomeStatementTableComponent,
      IncomeStatementChartComponent,
      FCashflowTableComponent,
      CashflowChartComponent,
      BalancesheetChartComponent,
      BalancesheetTableComponent,
      LoaderComponentComponent,
      RatioAnnualChartComponent,
      IncomeStatementAnnualChartComponent,
      CashflowAnnualChartComponent,
      BalancesheetAnnualChartComponent,
      BarChartComponent,
      TableComponent,
      AddListsCreateComponent,
      CompanyInfoComponent,
      KeyToLabelPipe,
      OrderByPipe,
      RankingGradePipe,
      currencyMilionPipe,
      MillionPipe,
      ProfileTextPipe,
      AbsPipe,
      CategoryToTextPipe,
      SumPipe,
      screaningMillionPipe,
      IriReportComponent,
      ScoreRadarCardComponent,
      IriLockComponent,
      RatingModalComponent,
      CompanyInfoComponent,
      MarketComparisonComponent,
      FaqsComponent,
      MarketComparisonComponent,
      // InvestorRelationsComponent,
      NewInvestmentChecklistComponent,
      DynamicTableComponent,
      MusaffaScoreComponent,
      CommunityScoreComponent,
      ScoreRatingSliderComponent,
      AssessmentSliderLeftComponent,
      AssessmentSliderRightComponent,
      IpoComponentComponent,
      IpoDataComponent,
      IpoDataLockComponent,
      IpoDetailsComponent,
      PremiumSamplePopupComponent,
      PurificationCalculatorComponent,
      PurificationOptionsComponent,
      EtfScreenerReportComponent,
      EtfScreeningDetailedReportComponent,
      LoginFormComponent,
      SignupFormComponent,
      VerifyOtpComponent,
      ForgotPasswordFormComponent,
      FacebookLoginComponent,
      AppleLoginComponent,
      GoogleSigninComponent,
   ],
   imports: [
      MainWrapperModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      NgSelectModule,
      NgChartsModule,
      NgbProgressbarModule,
      NgbPaginationModule,
      NgbDropdownModule,
      NgbTooltipModule,
      MatDatepickerModule,
      MatNativeDateModule,
      RouterModule,
      NgxSkeletonLoaderModule,
      NgbModule,
      NgOtpInputModule,
      CarouselModule,
      NgxMaskDirective,
      NgxMaskPipe,
      ShareButtons,
      ShareButtonDirective,
      MatProgressSpinnerModule,
      StockOverviewRoutingModule,
      AuthPopupComponent,
      SlugifyPipe,
   ],
   exports: [
      DetailsHeaderComponent,
      DetailsTabBtnsComponent,
      BuysellComponent,
      TradingViewComponent,
      TradingChartComponent,
      ComplianceStatusCardComponent,
      PurificationCardComponent,
      StockRecommendationComponent,
      FundamentalsComponent,
      InvestmentChecklistComponent,
      SuperinvestorsStockOverviewListComponent,
      TopUserCollectionsComponent,
      RelatedStocksComponent,
      ScreenerReportComponent,
      FeatureLockedCardComponent,
      StockFinancialsComponent,
      NoDataCardComponent,
      StockNewsComponent,
      StockPressReleasesComponent,
      StockProfileComponent,
      TooltipComponent,
      ForecastsComponent,
      AddListsComponent,
      LimitReachedCardComponent,
      LimitReachedPopupComponent,
      SampleBubbleComponent,
      RevenueBreakdownChartComponent,
      IncomeBreakdownComponent,
      DebtChartComponent,
      ProgresChartComponent,
      LessThanTooltipComponent,
      ForecastPriceDataSectionComponent,
      ForecastPriceChartComponent,
      ForecastDataSectionComponent,
      ForecastDataBarChartComponent,
      WatchlistButtonComponent,
      ShareLinksPopupComponent,
      ComplianceHistoryComponent,
      AnalystRatingGuageChartComponent,
      ComplianceChipComponent,
      PsDataComponent,
      RatiosTableComponent,
      RatiosChartComponent,
      FStatementsComponent,
      IncomeStatementComponent,
      BalancesheetComponent,
      FCashflowComponent,
      IncomeStatementTableComponent,
      IncomeStatementChartComponent,
      FCashflowTableComponent,
      CashflowChartComponent,
      BalancesheetChartComponent,
      BalancesheetTableComponent,
      LoaderComponentComponent,
      RatioAnnualChartComponent,
      IncomeStatementAnnualChartComponent,
      CashflowAnnualChartComponent,
      BalancesheetAnnualChartComponent,
      BarChartComponent,
      TableComponent,
      MatProgressSpinnerModule,
      CompanyInfoComponent,
      RankingGradePipe,
      currencyMilionPipe,
      MillionPipe,
      CategoryToTextPipe,
      screaningMillionPipe,
      AbsPipe,
      SumPipe,
      ProfileTextPipe,
      NewInvestmentChecklistComponent,
      DynamicTableComponent,
      IriReportComponent,
      CommonModule,
      PremiumSamplePopupComponent,
      PurificationCalculatorComponent,
      PurificationOptionsComponent,
      EtfScreenerReportComponent,
      EtfScreeningDetailedReportComponent,
      AuthPopupComponent,
      LoginFormComponent,
      SignupFormComponent,
      VerifyOtpComponent,
      ForgotPasswordFormComponent,
      FacebookLoginComponent,
      AppleLoginComponent,
      GoogleSigninComponent,
      FaqsComponent,
   ],
   providers: [
      screaningMillionPipe,
      DecimalPipe,
      DatePipe,
      SumPipe,
      shareIcons()
   ]
})
export class StockOverviewModule { }
